import {
  TreemapModule,
  createTreemapServices
} from "./chunk-BR22UD5L.mjs";
import "./chunk-NNHCCRGN.mjs";
export {
  TreemapModule,
  createTreemapServices
};
